import { Modal, Box } from "@mui/material";

const modalContainerSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& .MuiModal-backdrop": {
    backgroundColor: "#13159a33",
  },
};

const modalContentSx = {
  backgroundColor: "background.paper",
  boxShadow: (theme) => theme.shadows[5],
  padding: "30px 24px",
  maxWidth: 530,
  width: "100%",
  borderRadius: "12px",
};

function CustomModal({ open, children, width, sx }) {
  return (
    <Modal open={open} sx={modalContainerSx}>
      <Box sx={{ ...modalContentSx, width, ...sx }}>{children}</Box>
    </Modal>
  );
}

export default CustomModal;
